import { Component, ElementRef, EventEmitter, inject, Input, Output, signal, ViewChild, WritableSignal } from '@angular/core';
import { DragDrop } from '../../../directives/drag-drop';
import { UpdateService } from '../../../services/update-service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-import',
  imports: [DragDrop],
  templateUrl: './import.html',
  styleUrl: 'import.scss',
})
export class Import {

  @Input() dragDropEnabled = true;

  file = signal(undefined as File | undefined);
  uploading = signal(false);
  uploadStatusOk : WritableSignal<boolean | undefined> = signal(undefined);
  updateService = inject(UpdateService);
  private toastrService = inject(ToastrService);

  @ViewChild('fileInput')
  inputRef!: ElementRef<HTMLInputElement>;

  addFile(file: any): void {
    this.file.set(file);
  }

  handleFileDrop(event: DragEvent) {
    if (event?.dataTransfer?.files?.length) {
      const files = event.dataTransfer.files;
      this.inputRef.nativeElement.files = files;
      this.addFile(files[0]);
    }
  }

  removeFile(): void {
    this.file.set(undefined);
    this.inputRef.nativeElement.value = '';
  }

  uploadFile(): void {
    if (this.file()) {
      this.uploading.set(true);
      this.updateService.uploadFile(this.file()!)
        .then((response) => {
          this.uploadStatusOk.set(response.success);
        })
        .catch((error) => {
          this.uploadStatusOk.set(false);
          this.toastrService.error("Error lors de l'import du fichier", error);
        }).finally(
          () => this.uploading.set(false)
        );
    }
  }

    resetPage(): void {
      this.file.set(undefined);
      this.uploadStatusOk.set(undefined);
      this.inputRef.nativeElement.value = '';
  }
}
